
import { Navbar } from '../../components/feature/Navbar';
import { Footer } from '../../components/feature/Footer';
import { Card } from '../../components/base/Card';
import { Button } from '../../components/base/Button';

export default function DocumentsPage() {
  const documents = [
    {
      title: 'ISO 9001 Kalite Yönetim Sistemi',
      description: 'Kalite yönetim sistemi sertifikamız',
      type: 'Sertifika',
      date: '2023',
      icon: 'ri-award-line'
    },
    {
      title: 'OHSAS 18001 İş Sağlığı ve Güvenliği',
      description: 'İş sağlığı ve güvenliği yönetim sistemi',
      type: 'Sertifika',
      date: '2023',
      icon: 'ri-shield-check-line'
    },
    {
      title: 'ISO 14001 Çevre Yönetim Sistemi',
      description: 'Çevre yönetim sistemi sertifikamız',
      type: 'Sertifika',
      date: '2023',
      icon: 'ri-leaf-line'
    },
    {
      title: 'Yapı Denetim Yetki Belgesi',
      description: 'Yapı denetim hizmetleri yetki belgesi',
      type: 'Yetki Belgesi',
      date: '2024',
      icon: 'ri-file-shield-line'
    },
    {
      title: 'İnşaat Müteahhitlik Belgesi',
      description: 'Birinci grup inşaat müteahhitlik belgesi',
      type: 'Yetki Belgesi',
      date: '2024',
      icon: 'ri-building-line'
    },
    {
      title: 'Çevre Dostu Yapı Sertifikası',
      description: 'Sürdürülebilir inşaat uygulamaları sertifikası',
      type: 'Sertifika',
      date: '2023',
      icon: 'ri-plant-line'
    },
    {
      title: 'Mesleki Yeterlilik Belgesi',
      description: 'İnşaat mühendisliği mesleki yeterlilik',
      type: 'Yeterlilik',
      date: '2024',
      icon: 'ri-user-star-line'
    },
    {
      title: 'Ticaret Sicil Gazetesi',
      description: 'Şirket kuruluş ve faaliyet belgesi',
      type: 'Resmi Belge',
      date: '1999',
      icon: 'ri-file-text-line'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero */}
      <section className="pt-24 pb-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-[28px] font-bold text-[#0e3851] mb-4">
              Belgeler & Sertifikalar
            </h1>
            <p className="text-[16px] text-gray-600 max-w-3xl mx-auto">
              Kalite standartlarımızı ve yetkinliklerimizi belgeleyen 
              sertifika ve yetki belgelerimiz
            </p>
          </div>
        </div>
      </section>

      {/* Belgeler Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {documents.map((doc, index) => (
              <Card key={index} hover>
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#0e3851]/10 rounded-xl flex-shrink-0">
                    <i className={`${doc.icon} text-[20px] text-[#0e3851]`}></i>
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center justify-between mb-2">
                      <span className="text-[12px] font-medium text-[#0e3851] bg-[#0e3851]/10 px-2 py-1 rounded-full">
                        {doc.type}
                      </span>
                      <span className="text-[12px] text-gray-500">{doc.date}</span>
                    </div>
                    <h3 className="text-[16px] font-semibold text-[#0e3851] mb-2 leading-tight">
                      {doc.title}
                    </h3>
                    <p className="text-[14px] text-gray-600 mb-4">
                      {doc.description}
                    </p>
                    <Button size="sm" variant="outline" className="w-full">
                      <i className="ri-download-line mr-2"></i>
                      İndir
                    </Button>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Kalite Politikası */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-[22px] font-semibold text-[#0e3851] mb-4">
              Kalite Politikamız
            </h2>
            <p className="text-[15px] text-gray-600 max-w-3xl mx-auto">
              Tüm faaliyetlerimizde uyguladığımız kalite standartları ve ilkeler
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <Card>
                <h3 className="text-[18px] font-semibold text-[#0e3851] mb-4">
                  Kalite Taahhüdümüz
                </h3>
                <div className="space-y-3 text-[15px] text-gray-600">
                  <div className="flex items-start">
                    <i className="ri-check-line text-[#0e3851] mt-1 mr-3"></i>
                    <span>Uluslararası kalite standartlarına tam uyum</span>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-check-line text-[#0e3851] mt-1 mr-3"></i>
                    <span>Sürekli iyileştirme ve gelişim odaklı yaklaşım</span>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-check-line text-[#0e3851] mt-1 mr-3"></i>
                    <span>Müşteri memnuniyeti öncelikli hizmet anlayışı</span>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-check-line text-[#0e3851] mt-1 mr-3"></i>
                    <span>Çevre dostu ve sürdürülebilir inşaat uygulamaları</span>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-check-line text-[#0e3851] mt-1 mr-3"></i>
                    <span>İş sağlığı ve güvenliği öncelikli çalışma ortamı</span>
                  </div>
                </div>
              </Card>
            </div>
            <div>
              <img 
                src="https://public.readdy.ai/ai/img_res/d180c408f9921083f53235699fedbe63.jpg"
                alt="Kalite Kontrol"
                className="w-full h-80 object-cover rounded-2xl shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* İletişim CTA */}
      <section className="py-16 bg-[#0e3851] text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-[22px] font-semibold mb-4">
            Belgelerimiz Hakkında Detaylı Bilgi
          </h2>
          <p className="text-[16px] text-gray-300 mb-8">
            Sertifikalarımız ve kalite standartlarımız hakkında daha fazla bilgi almak için 
            bizimle iletişime geçin.
          </p>
          <Button size="lg" className="bg-white text-[#0e3851] hover:bg-gray-100">
            <i className="ri-phone-line mr-2"></i>
            İletişime Geç
          </Button>
        </div>
      </section>

      <Footer />
    </div>
  );
}
